
var pym = require("./lib/pym");
var ANALYTICS = require("./lib/analytics");
require("./lib/webfonts");
var $ = require("./lib/qsa");

// Global vars
var quiz = null;
var results = null;
var pymChild = null;

var numQuestions = 0;
var numTaken = 0;
var numCorrect = 0;
var numWrong = 0
var numRemaining = 0;
var promptsRight = [];
var promptsWrong = [];
var $finalResults = null

console.clear();

/*
 * Initialize the graphic.
 */
var onWindowLoaded = function () {
  quiz = document.querySelector("#quiz");
  results = document.querySelector("#results");
  $finalResults = $('#finalResults');

  numQuestions = quiz.querySelectorAll(".question").length;
  var questions = quiz.querySelectorAll("li strong");
  questions.forEach((q, i) => {
    q.addEventListener("click", onAnswerClicked);
  });

  promptsRight = PROMPTS.filter(d => d.type == "right");
  promptsWrong = PROMPTS.filter(d => d.type == "wrong");

 
  pym.then(child => {
    pymChild = child;
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

var onSocialLinkClicked = function (evt) {
  ANALYTICS.trackEvent(evt.target.dataset.track, evt.target.dataset.label);
}


/*
 * Quiz
 */
var onAnswerClicked = function (evt) {
  var thisAnswer = evt.target;
  var thisQuestion = evt.target.parentNode.parentNode.parentNode.parentNode;
  var thisQuestionNumber = Number(thisQuestion.parentNode.dataset.question);
  var allAnswers = thisQuestion.querySelectorAll("strong");
  var resultsMsg = '';

  // check if the user selected the correct answer
  var gotItRight = thisAnswer.parentNode.classList.contains("correct");

  if (gotItRight) {
    // register that this question has been answered
    thisQuestion.classList.add("answered");
    numTaken++;
    numRemaining = numQuestions - numTaken;
    allAnswers.forEach((a, i) => {
      a.removeEventListener("click", onAnswerClicked);
    });

    // tell the user if they got it right
    var answerLabel = document.createElement("b");
    answerLabel.textContent = promptsRight[Math.floor(Math.random() * promptsRight.length)].message;
    numCorrect++;
    thisAnswer.prepend(answerLabel);
    thisAnswer.parentNode.classList.add("selected");

  } else {
    // register that this question has been answered
    thisQuestion.classList.add("answered");
    numTaken++;
    numRemaining = numQuestions - numTaken;
    allAnswers.forEach((a, i) => {
      a.removeEventListener("click", onAnswerClicked);
    });

    //tell the user they got it wrong
    answerLabel = document.createElement("b");
    answerLabel.textContent = promptsWrong[Math.floor(Math.random() * promptsWrong.length)].message;
    numWrong++;
    thisAnswer.prepend(answerLabel);
    thisAnswer.parentNode.classList.add("selected");

  }

  // if all questions have been answered, show a message relative to score
  if (numTaken == numQuestions) {
    results.classList.add("final");
    var resultsTopline = results.querySelector("#answered-correct");
    resultsTopline.innerHTML = numCorrect;

    if (numCorrect <= 2) {
      resultsMsg += FINAL_LOW;
    } else if (numCorrect >= 3 && numCorrect <= 5) {
      resultsMsg += FINAL_MID1;
    } else if (numCorrect >= 6 && numCorrect <= 8) {
      resultsMsg += FINAL_MID2;
    } else if (numCorrect >= 9) {
      resultsMsg += FINAL_HIGH;
    }

    var finalResults = results.querySelector("#finalResults");
    finalResults.innerHTML = resultsMsg;

    // console.log(FINAL_MID2);

    ANALYTICS.trackEvent("questions-answered", "8");

  } else {
    results.classList.add("active");
    var resultsMsgCounter = results.querySelector("#answered-count");
    resultsMsgCounter.innerHTML = numTaken;

    // show the next question
    var nextQuestionSelector = `[data-question='${(thisQuestionNumber + 1)}']`;
    var nextQuestion = document.querySelector(nextQuestionSelector);
    // console.log(nextQuestion, thisQuestionNumber);
    nextQuestion.classList.add("active");
    ANALYTICS.trackEvent("questions-answered", numTaken);
  }

}
// update the iframe height
if (pymChild) {
  pymChild.sendHeight();
}

/*
 * Initially load the graphic
 * (NB: Use window.load to ensure all images have loaded)
 */
window.onload = onWindowLoaded;
